var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 359.14 139.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003a70;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CNM_Logos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 359.14,
    height: 139.33
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.09,35.08h23.29l19.84,28.7h.2l0-28.7h21.7V104H161.37L137.3,72.58h-.19L137.06,104h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189,35.08h32.23l10.51,35.7h.2l10.33-35.7H274.1V104H253.5V67.36h-.19L241.24,104H222L209.88,67.28h-.19V104H189Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "280.67 35.02 280.67 49.94 306.37 69.28 280.67 89.2 280.67 104 309.63 81.22 309.63 57.37 280.67 35.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.06,81.67V57l16.1,12.33ZM310.13,59V79.63l13.39-10.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.38,69.87C70.29,77.64,78.26,85.5,92.65,84a66.29,66.29,0,0,0,15.49-3.15v20.65c-6.07,2.2-9.52,3.94-23.56,4.19,0,0-43.48,3.74-43.07-36.5v.11C41.66,29,85.09,33.35,85.09,33.35c14,.45,17,2.23,23,4.51V58.51a64.86,64.86,0,0,0-15.29-3.35c-14.37-1.73-22.46,6-22.47,13.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78a9e88876a32891ab4d794e15bef2aa.svg";
export { ForwardRef as ReactComponent };